import { ApplicationState } from '../../../../store/types';
import { getClientsRoot } from '../../store/selectors';
import { Client, ClientFeaturePermissionDB, ClientSection, RejectedQuestionsByUser, RejectedQuestionsToForgive } from './types';

export const getModalOpen = (state: ApplicationState): boolean => getClientsRoot(state).modalOpen;

export const getAllClients = (state: ApplicationState): Client[] => getClientsRoot(state).clients;

export const getAllClientIds = (state: ApplicationState): number[] => getClientsRoot(state).clients.map(({ clientId }) => clientId!);

export const getSelectedClient = (state: ApplicationState): Client | null => getClientsRoot(state).selectedClient;

export const getSelectedClientId = (state: ApplicationState): number | undefined => getSelectedClient(state)?.clientId;

export const getConfirmDeleteClient = (state: ApplicationState): Client | null => getClientsRoot(state).confirmDeleteClient;

export const getIsDeleting = (state: ApplicationState): boolean => getClientsRoot(state).deletingClient;

export const getAvailableClientFeaturePermissions = (state: ApplicationState): ClientFeaturePermissionDB[] => getClientsRoot(state).availableClientFeaturePermissions;

export const getOpenClientSection = (state: ApplicationState): ClientSection => getClientsRoot(state).openClientSection;

export const getIsDownloading = (state: ApplicationState): boolean => getClientsRoot(state).isDownloading;

export const getIsUploading = (state: ApplicationState): boolean => getClientsRoot(state).isUploading;

export const getFilesToUpload = (state: ApplicationState): File[] => getClientsRoot(state).filesToUpload;

export const getRejectedQuestionsByUser = (state: ApplicationState): RejectedQuestionsByUser[] => getClientsRoot(state).rejectedQuestions;

export const getRejectedQuestionsToForgive = (state: ApplicationState): RejectedQuestionsToForgive[] => getClientsRoot(state).rejectedQuestionsToForgive;

export const getIsFetchingRejectedQuestions = (state: ApplicationState): boolean => getClientsRoot(state).isFetchingRejectedQuestions;

export const getSelectedClientFewShotAgreementTypeId = (state: ApplicationState): number | null => getClientsRoot(state).selectedFewShotAgreementTypeId;
